import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../../../utils/hooks/useMutationWithError";
import {
  UpdateDefaultSquareCardOnFileInput,
  useSetDefaultCardOnFileMutation,
} from "./__generated__/useSetDefaultCardOnFileMutation.graphql";

export const useSetDefaultCardOnFile = () => {
  const [updateDefaultSquareCardOnFile, isUpdatingDefaultSquareCardOnFile] =
    useMutationWithError<useSetDefaultCardOnFileMutation>(
      useSetDefaultCardOnFileMutationString
    );

  const handleUpdateDefaultCard = (
    input: UpdateDefaultSquareCardOnFileInput
  ) => {
    updateDefaultSquareCardOnFile({
      variables: { input },
      onCompleted: () => {},
    });
  };

  return [handleUpdateDefaultCard, isUpdatingDefaultSquareCardOnFile] as const;
};

const useSetDefaultCardOnFileMutationString = graphql`
  mutation useSetDefaultCardOnFileMutation(
    $input: UpdateDefaultSquareCardOnFileInput!
  ) {
    responsePayload: updateDefaultSquareCardOnFile(input: $input) {
      errors {
        field
        message: code
      }
      success
      user {
        ... on MemberUser {
          squareCards(enabled: true) {
            edges {
              node {
                id
                cardBrand
                lastFour
                enabled
                ...SquareCardFragment
                ...SelectedPaymentMethodFragment
              }
            }
          }
        }
      }
    }
  }
`;
